import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToScoutBanner = {
  [titleId: string]: WpsTypes.atv.wps.ScoutBannerModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.scoutBanner,
  {} as TitleIdToScoutBanner
)